import React from 'react'
import PropTypes from 'prop-types'
import Link from '../utils/Link'
import FeaturedLabel from '../utils/FeaturedLabel'
import { isFeatured } from '../utils/Article'

/**
 * ListBox Component
 */
const ListBox = props => {
  const {
    box: {
      link,
      title,
      featuredType
    },
    className,
    featuredClass,
    onMouseOver,
    onMouseOut
  } = props

  const checkLabel = isFeatured(featuredType)

  return (
    <li className={className} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
      <Link href={link}>
        <span className={`title${checkLabel ? ' label' : ''}`}>
          { title }
        </span>
        {
          checkLabel &&
          <FeaturedLabel title={featuredType} featuredClass={featuredClass}/>
        }
      </Link>
    </li>
  )
}
ListBox.propTypes = {
  box: PropTypes.object.isRequired,
  className: PropTypes.string,
  featuredClass: PropTypes.string,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func
}

export default ListBox
